/* eslint-disable import/order */
import { ChangeEvent, forwardRef, useCallback } from "react";
import { ITexareaProps } from "./i-textarea";
import {
   ErrorP,
   AdornmentWrapperDiv,
   InputFieldWrapperDiv,
   Div,
   TextAreaField,
   Label,
} from "./textarea.style";

const Textarea = forwardRef<HTMLTextAreaElement, ITexareaProps>(
   (
      {
         id,
         name,
         label,
         required,
         value,
         error,
         fullWidth,
         className,
         onChange,
         startAdornment,
         endAdornment,
         isMobile,
         labelColor,
         ...remainingProps
      },
      ref
   ) => {
      const labelId = label ? `${id}-label` : undefined;
      const errorId = error ? `${id}-error-text` : undefined;

      const handleChange = useCallback(
         (event: ChangeEvent<HTMLTextAreaElement>) => {
            onChange?.(event);
         },
         [onChange]
      );

      return (
         <Div fullWidth={fullWidth} className={className}>
            {label && (
               <Label id={labelId} htmlFor={id} style={{ color: labelColor }}>
                  {`${label}`} <span style={{ color: "red" }}>{required ? "*" : ""}</span>
               </Label>
            )}
            <InputFieldWrapperDiv>
               {startAdornment && <AdornmentWrapperDiv>{startAdornment}</AdornmentWrapperDiv>}
               <TextAreaField
                  id={id}
                  ref={ref}
                  name={name}
                  value={value}
                  // required={required}
                  aria-invalid={!!error}
                  aria-describedby={errorId}
                  onChange={handleChange}
                  error={error}
                  startAdornment={startAdornment}
                  isMobile={isMobile}
                  {...remainingProps}
                  rows={100}
               />
            </InputFieldWrapperDiv>
            {error && (
               <ErrorP
                  initial="pageInitial"
                  animate="pageAnimate"
                  exit="pageExit"
                  variants={{
                     pageInitial: {
                        opacity: 1,
                        x: 0,
                        y: -5,
                     },
                     pageAnimate: {
                        opacity: 1,
                        x: 0,
                        y: 0,
                     },
                     pageExit: {
                        opacity: 0,
                     },
                  }}
                  id={errorId}
               >
                  {error}
               </ErrorP>
            )}
         </Div>
      );
   }
);

Textarea.displayName = "input";

export { Textarea };
